export default {
    address:'address',
    province:'Province',
    city: 'City',
    country: 'Country',
    postalCode: 'Postal Code',
    home: 'Home',
    work: 'Work',
    type: 'Type'
}